<script lang="ts">
    import { apiBaseURL } from "../config"
    import { sprache, i18n } from "../store"

    export let person: Person

    function adresse(firma: string): string {
        return {
            SFUP: $i18n("Stiftung Familienunternehmen und Politik"),
            SFU: $i18n("Stiftung Familienunternehmen"),
            HFU: $i18n("Haus des Familienunternehmens"),
            RB: $i18n("Haus des Familienunternehmens Brüssel"),
        }[firma]
    }

    function link(firma: string): string {
        return {
            SFUP: '<a href="https://www.familienunternehmen-politik.de/">www.familienunternehmen-politik.de</a>',
            SFU: '<a href="https://www.familienunternehmen.de/">www.familienunternehmen.de</a>',
            HFU: '<a href="https://www.familienunternehmen-politik.de/">www.familienunternehmen-politik.de</a>',
            RB: '<a href="https://www.familienunternehmen-politik.de/">www.familienunternehmen-politik.de</a>',
        }[firma]
    }
</script>

<div class="item">
    <div class="image">
        <div class="bg"></div>
        <img
            src="{apiBaseURL +
                '/personen/' +
                person.id +
                '/' +
                person.bild?.src +
                '?filter=l'}"
            alt="{person.name}"
        />
    </div>
    <div class="text">
        <h4>{person.name}</h4>
        <div class="position">{person.funktion[$sprache] || ""}</div>
        <p class="address">
            {@html adresse(person.firma)}
        </p>
        {#if person.adresse && person.adresse[$sprache]}
            <p>{@html person.adresse[$sprache]}</p>
        {/if}
        <p>
            {$i18n("Telefon")}:
            {person.telefon}<br />
            {$i18n("Telefax")}:
            {person.fax}
        </p>
        <p>
            E-Mail:
            {person.email}
            <!--<br />
            Internet:
            {@html link(person.firma)}
            -->
        </p>
    </div>
</div>

<style lang="less">
    @import "../css/base.less";

    .item {
        width: 50%;
        padding: 15px;
        .flex();
        align-items: flex-start;
        @media (max-width: 1300px) {
            width: 100%;
        }
        @media (max-width: 768px) {
            flex-direction: column;
        }
        .image {
            position: relative;
            width: 200px;
            flex-shrink: 0;
            margin-right: 25px;
            line-height: 0;
            border-radius: 100px;
            overflow: hidden;
            @media (max-width: 768px) {
                margin-bottom: 20px;
            }
            img {
                width: 100%;
                z-index: 2;
                position: relative;
            }
            .bg {
                background: #828282;
                width: 200px;
                height: 200px;
                border-radius: 100%;
                position: absolute;
                bottom: 0;
                z-index: 1;
            }
        }
        .text {
            h4 {
                margin: 0px;
                font-weight: 700;
            }
            .position {
                margin-bottom: 20px;
            }
        }
    }
</style>
